import { useEffect, useState } from "react"

import { useChat } from "../hooks/use-chat"
import { ChatsList } from "./chats-list"
import { ConnectingAdvisor } from "./connecting-advisor"
import { ChatConversation } from "./chat-conversation"

/**
 * Readings tab root flow (ported from LiveChat.tsx):
 * no advisor -> conversations list; advisor selected -> connecting -> chat.
 */
export function LiveChatPage() {
  const { selectedAdvisor } = useChat()
  const [isChatStarted, setIsChatStarted] = useState(false)

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    if (selectedAdvisor === null) setIsChatStarted(false)
  }, [selectedAdvisor])

  if (!selectedAdvisor) return <ChatsList />

  if (!isChatStarted) {
    return (
      <ConnectingAdvisor selectedAdvisor={selectedAdvisor} onStart={() => setIsChatStarted(true)} />
    )
  }

  return <ChatConversation selectedAdvisor={selectedAdvisor} />
}
